import { type ScrollView, StyleSheet, View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';

import { LogoSvg, iosVerticalScrollContentContainerStyle } from '@fhs/ui';

import { useAuthScroll } from '../../auth-scroll-context';
import { AuthHeader } from '../auth-header';

import { AuthContainerProps } from '.';

const APP_HEADER_HEIGHT = 56;

export function AuthContainerMobile({ children }: AuthContainerProps) {
  const insets = useSafeAreaInsets();
  const { scrollRef } = useAuthScroll();

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.authHeader}>
        <AuthHeader backgroundHeight={60} imageHeight={150} />
      </View>
      <KeyboardAwareScrollView
        innerRef={ref => {
          scrollRef.current = ref as unknown as ScrollView;
        }}
        style={styles.scrollView}
        contentContainerStyle={[styles.scrollContent, iosVerticalScrollContentContainerStyle]}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
        enableOnAndroid
        extraScrollHeight={APP_HEADER_HEIGHT + insets.top}
      >
        <LogoSvg style={styles.logo} />
        <View style={styles.content}>{children}</View>
      </KeyboardAwareScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  authHeader: {
    position: 'absolute',
    top: 0,
    width: '100%',
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    flexShrink: 0,
    gap: 20,
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 32,
    paddingBottom: 48,
  },
  content: {
    width: '100%',
  },
  iconButton: {
    position: 'absolute',
    marginHorizontal: 16,
    marginVertical: 12,
  },
  logo: { alignSelf: 'center' },
});
